import { useState, useEffect } from "react";

export const useEnlargeBackImg = () => {
  const [backgroundSize, setBackgroundSize] = useState("cover");

  const handleScroll = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const scrollPosition = window.scrollY;

    const newSize =
      width > 600
        ? width * (1 + scrollPosition / 2000) + "px"
        : height * (1 + scrollPosition / 2000) + "px";

    const heroText = document.querySelector(".cust-hero-text");
    const heroBadge = document.querySelector(".cust-hero-badge");
    if (!heroText || !heroBadge) return;
    heroText.style.opacity = `${(-window.scrollY + 300) * 0.004}`;
    heroBadge.style.opacity = `${(-window.scrollY + 650) * 0.004}`;

    setBackgroundSize(`${newSize}`);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [backgroundSize]);

  return backgroundSize;
};
